module.exports = __webpack_public_path__ + "img/kutatasi jelentes_gomb_aktiv.1008a870.png";